import { GenericSetState, GenericSetStates } from "@/store/helpers";
import { DefineMutations } from "vuex-type-helper";
import { EmergencyMutations, EmergencyState, StateKeys } from "./types";
import * as types from "@/store/mutation-types";

export const mutations: DefineMutations<EmergencyMutations, EmergencyState> = {
  [types.SET_STATE]: GenericSetState<EmergencyState, StateKeys>(),
  [types.SET_STATES]: GenericSetStates<EmergencyState>()
};
